module.exports = __webpack_public_path__ + "img/close.db59a9f2.svg";